<template>
    <footer>
      <p>© 2024 Gogo Saporu</p>
    </footer>
  </template>
  
  <script>
  export default {
    name: "AppFooter",
  };
  </script>
  
  <style scoped>
  footer {
    text-align: center;
    padding: 1em;
  }
  </style>
  